import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as appActions from './actions/app-actions';
import AlbumArt from './AlbumArt';

class NowPlaying extends Component {

  render(){
    return (
      <div className="NowPlaying">
        <AlbumArt 
          album={ this.props.currentTrack.album } 
          albumArtUrl={ this.props.currentTrack.album_art.large } />
        <h1>{ this.props.player.title }</h1>
        <h2 className="Artist">{ this.props.currentTrack.title }</h2>
        <h2 className="Title">{ this.props.currentTrack.artist }</h2>
      </div>
    );
  }
}

function mapStateToProps(state){
    return {
        player: state.app.player.toJS()
    };
}

function mapDispatchToProps(dispatch){
    return {
        appActions: bindActionCreators(appActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NowPlaying);



// WEBPACK FOOTER //
// ./src/NowPlaying.js